import { preload } 		from './modules/mod_preload'
import { navigation } 	from './modules/mod_navigation'
import { slider } 		from './modules/mod_slider'
import { counter } 		from './modules/mod_counter'
import { iframeHeight } 	from './modules/mod_iframe'

window.onload = function () {
	preload()
	navigation()
	slider()
	counter()
	iframeHeight()
}
